var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCss9Ed7063D(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 126,
    viewBox: "0 0 89 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.1618 125.673L8.29016 115.597L0.296143 24.8765H88.1349L80.1326 115.583L44.1618 125.673Z",
    fill: "#264DE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2818 109.807L80.1199 32.2944H44.2156V117.961L73.2818 109.807Z",
    fill: "#2965F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6221 65.9412L19.6075 77.0676H44.2155V65.9412H18.6221Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6416 43.4209L17.6412 54.5474H44.2156V43.4209H16.6416Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2155 94.8379L44.1673 94.8508L31.9207 91.5049L31.1377 82.6311H20.0989L21.6394 100.101L44.1649 106.428L44.2155 106.414V94.8379Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9686 0.222656H34.2868V5.85818H26.5383V11.4937H34.2875V17.1289H20.9686V0.222656Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9508 0.222656H50.2693V5.12309H42.5205V6.1031H50.2693V17.3742H36.9511V12.2281H44.7V11.2481H36.9504V0.222656H36.9508Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9333 0.222656H66.2519V5.12309H58.503V6.1031H66.2519V17.3742H52.9333V12.2281H60.6822V11.2481H52.9337V0.222656H52.9333Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7388 65.9411L71.7238 43.4209H44.1777V54.5474H59.6727L58.6721 65.9411H44.1777V77.0675H57.7187L56.442 91.4978L44.1774 94.8472V106.423L66.7209 100.101L66.8861 98.2213L69.4706 68.9288L69.7388 65.9411Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88.1452,
    height: 125.768,
    fill: "white",
    transform: "translate(0.142944 0.222656)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss9Ed7063D);
export default __webpack_public_path__ + "static/media/css.9ed7063d.9ed7063df2564acb25024e3dac3d2a0b.svg";
export { ForwardRef as ReactComponent };